import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthCheck } from '../auth/auth.check';
import { WorkflowDashboardComponent } from './workflow-dashboard/workflow-dashboard.component';
import { WorkflowDesignerComponent } from './workflow-designer/workflow-designer.component';

const routes: Routes = [

  // {path: "workflow-dashboard", component: WorkflowDashboardComponent},
  {path: "workflow-designer", component: WorkflowDesignerComponent,canActivate:[AuthCheck]}
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WorkflowRoutingModule { }
